import React, { useContext } from 'react';
import styled from 'styled-components';
import { StoreContext } from '../context/StoreContext';
import { brandFonts, visuallyHidden } from '../styles';
import { isOnSale, formatPrice } from '../utils';

const StyledPrice = styled.p`
  font-family: ${brandFonts.secondary};
`;

const StyledOldPrice = styled.s`
  margin-right: 10px;
`;

const StyledLabel = styled.span`
  ${visuallyHidden()};
`;

export const ProductPrice = ({
  priceRange: { minVariantPrice, maxVariantPrice },
  variants,
  ...props
}) => {
  const { currency } = useContext(StoreContext);
  const hasSalePrice = isOnSale(variants, currency);

  let lowestCompareAtPrice;

  if (hasSalePrice) {
    const variantsOnSale = variants.filter(({ presentmentPrices }) => {
      const { compareAtPrice, price } = presentmentPrices.find(
        ({ price }) => price && price.currencyCode === currency
      );
      return (
        compareAtPrice !== null &&
        parseFloat(price.amount) < parseFloat(compareAtPrice.amount)
      );
    });

    if (variantsOnSale.length > 1) {
      variantsOnSale.sort((a, b) => {
        const priceA = a.presentmentPrices.find(
          ({ price }) => price && price.currencyCode === currency
        );
        const priceB = b.presentmentPrices.find(
          ({ price }) => price && price.currencyCode === currency
        );
        return (
          parseFloat(priceA.compareAtPrice.amount) -
          parseFloat(priceB.compareAtPrice.amount)
        );
      });
    }

    const { compareAtPrice } = variantsOnSale[0].presentmentPrices.find(
      ({ price }) => price && price.currencyCode === currency
    );

    lowestCompareAtPrice = compareAtPrice;
  }

  // Sort by lowest priced variant
  const sortedVariants = variants.sort((a, b) => {
    const priceA = a.presentmentPrices.find(
      ({ price }) => price && price.currencyCode === currency
    );
    const priceB = b.presentmentPrices.find(
      ({ price }) => price && price.currencyCode === currency
    );
    return parseFloat(priceA.price.amount) - parseFloat(priceB.price.amount);
  });

  const { price } = sortedVariants[0].presentmentPrices.find(
    ({ price }) => price && price.currencyCode === currency
  );

  return (
    <StyledPrice {...props}>
      {hasSalePrice && (
        <StyledOldPrice>
          {formatPrice(lowestCompareAtPrice.amount, currency)}
        </StyledOldPrice>
      )}
      <StyledLabel>{hasSalePrice ? 'Sale price' : 'Regular price'}</StyledLabel>
      {minVariantPrice.amount !== maxVariantPrice.amount ? 'From ' : ''}
      {formatPrice(price.amount, price.currencyCode)}
    </StyledPrice>
  );
};

export const VariantPrice = ({ variant, ...props }) => {
  const { currency } = useContext(StoreContext);
  const hasSalePrice = isOnSale([variant], currency);
  const { price, compareAtPrice } = variant.presentmentPrices
    ? variant.presentmentPrices.find(
        ({ price }) => price && price.currencyCode === currency
      )
    : variant;

  return (
    <StyledPrice {...props}>
      {hasSalePrice && (
        <StyledOldPrice>
          {formatPrice(compareAtPrice.amount, currency)}
        </StyledOldPrice>
      )}
      <StyledLabel>{hasSalePrice ? 'Sale price' : 'Regular price'}</StyledLabel>
      {formatPrice(price > 0 ? price : price.amount, currency)}
    </StyledPrice>
  );
};
